export const DEFAULT_ESTIMATED_DELIVERY_DAYS = 15;

export function localeFromAppLanguage(language?: string): string {
  const lng = language?.split("-")[0] ?? "pt";
  if (lng === "en") return "en-US";
  if (lng === "es") return "es-ES";
  return "pt-BR";
}

export type FormatEstimatedDeliveryDateOptions = {
  language?: string;
  daysFromNow?: number;
  referenceDate?: Date;
};

export function formatEstimatedDeliveryDate(
  options: FormatEstimatedDeliveryDateOptions = {},
): string {
  const {
    language,
    daysFromNow = DEFAULT_ESTIMATED_DELIVERY_DAYS,
    referenceDate = new Date(),
  } = options;

  const d = new Date(referenceDate);
  d.setDate(d.getDate() + daysFromNow);

  const locale = localeFromAppLanguage(language);

  return new Intl.DateTimeFormat(locale, {
    weekday: "long",
    day: "numeric",
    month: "long",
  }).format(d);
}
